module.exports = __webpack_public_path__ + "static/orientatation-c3a9d34366c30229253ca27c00056632.svg";